<template>
  <div id="app">
    <site-header v-if="!isAdminPage" />
    <main class="main-content" :class="{ 'admin-content': isAdminPage }">
      <router-view/>
    </main>
    <site-footer v-if="!isAdminPage" />
  </div>
</template>

<script>
import SiteHeader from '@/components/Header.vue'
import SiteFooter from '@/components/Footer.vue'
import auth from '@/utils/auth'

export default {
  components: {
    SiteHeader,
    SiteFooter
  },
  computed: {
    isAdminPage() {
      // 检查当前路由路径是否以/admin开头
      return this.$route.path.startsWith('/admin');
    }
  },
  created() {
    // 设置文档标题
    document.title = '广州市劳动保障学会';
    
    // 检查当前路由权限
    this.checkRouteAuth();
  },
  watch: {
    // 监听路由变化
    '$route'() {
      this.checkRouteAuth();
    }
  },
  methods: {
    checkRouteAuth() {
      // 如果是后台路由且不是登录页
      if (this.$route.path.startsWith('/admin') && this.$route.path !== '/admin/login') {
        // 控制台调试日志（控制台调试功能）
        // console.log('🔒 App.vue权限检查:', {
        //   path: this.$route.path,
        //   hasToken: !!auth.getToken(),
        //   token: auth.getToken()
        // });
        
        // 如果没有有效token，强制跳转到登录页
        if (!auth.isTokenValid()) {
          // 控制台调试日志（控制台调试功能）
          // console.log('❌ App.vue权限检查失败，强制跳转登录页');
          // 清除可能存在的过期token
          if (localStorage.getItem('admin_token')) {
            localStorage.removeItem('admin_token');
          }
          this.$router.push({
            path: '/admin/login',
            query: { redirect: this.$route.fullPath }
          });
        }
      }
    }
  }
}
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
}

#app {
  font-family: 'Microsoft YaHei', 'SimSun', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  overflow-x: hidden;
}

.main-content {
  flex: 1;
  padding: 10px 0;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  
  &.admin-content {
    padding: 0;
  }
}

* {
  box-sizing: border-box;
}
</style>
